

















































































































































// Email Validation
import freeEmailDomains from '../assets/emailDomains/freeEmailDomains.json'; // https://www.npmjs.com/package/free-email-domains
import disposableEmailDomains from '../assets/emailDomains/disposableEmailDomains.json'; //https://github.com/disposable-email-domains/disposable-email-domains
import parser from 'tld-extract';
import i18n from '@/i18n';

const isDev = process.env.NODE_ENV === 'development';

const validateEmail = (email: string | undefined) => {
	const regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return email ? regexEmail.test(email) : false;
};

const getEmailDomain = async (email: string): Promise<string> => {
	return new Promise(async (resolve, reject) => {
		try {
			const broken = email.split('@');
			const address = `http://${broken[broken.length - 1]}`;
			const { domain } = parser(address);
			resolve(domain);
		} catch (error) {
			reject(i18n.t('create.validation.workEmailInvalid'));
		}
	});
};

const isCompanyEmail = async (email: string): Promise<boolean> => {
	try {
		if (!validateEmail(email)) throw new Error(i18n.t('create.validation.workEmailInvalid') as string);
		const domain = await getEmailDomain(email);
		return !freeEmailDomains.includes(domain);
	} catch (error) {
		throw new Error(error);
	}
};

const isDisposableEmail = async (email: string): Promise<boolean> => {
	try {
		if (!validateEmail(email)) throw new Error(i18n.t('create.validation.workEmailInvalid') as string);
		const domain = await getEmailDomain(email);
		return disposableEmailDomains.includes(domain);
	} catch (error) {
		throw new Error(error);
	}
};
export default {
	name: 'Create',
	data() {
		const validatePass: Function = (rule, value, callback) =>
			value !== this.form.password ? callback(new Error('error')) : callback();
		const validateId: Function = (rule, value, callback) =>
			/(?=^[a-z])(?=^[a-zA-Z0-9_-]*$)/.test(value) ? callback() : callback(new Error('error'));
		const idTaken: Function = (rule, value, callback) =>
			this.tenantList.includes(value) ? callback(new Error('error')) : callback();
		const idForbidden: Function = (rule, value, callback) =>
			this.forbiddenIds.includes(value) ? callback(new Error('error')) : callback();
		const validateEmailInput = async (rule, value, callback) => {
			if (!validateEmail(value)) return callback(new Error(i18n.t('create.validation.workEmailInvalid') as string));
			if (!(await isCompanyEmail(value)))
				return callback(new Error(i18n.t('create.validation.notCompanyEmail', { email: value }) as string));
			if (!isDev && (await isDisposableEmail(value)))
				return callback(new Error(i18n.t('create.validation.disposableEmail', { email: value }) as string));
			return callback();
		};

		return {
			step: 0,
			loading: false,
			loadingText: this.$t('create.creating'),
			tenantList: [],
			description: [
				this.$t('create.steps.company'),
				this.$t('create.steps.personal'),
				this.$t('create.steps.password'),
				this.$t('create.steps.summary'),
			],
			form: {
				email: '',
				organizationName: '',
				organizationId: '',
			},
			rules: {
				firstName: [{ required: true, message: this.$t('create.validation.firstNameRequired'), trigger: 'blur' }],
				lastName: [{ required: true, message: this.$t('create.validation.lastNameRequired'), trigger: 'blur' }],
				email: [
					{ required: true, message: this.$t('create.validation.emailRequired'), trigger: 'blur' },
					{ validator: validateEmailInput, trigger: ['blur', 'change'] },
				],
				organizationName: [
					{ required: true, message: this.$t('create.validation.companyNameRequired'), trigger: ['blur', 'change'] },
				],
				organizationId: [
					{ required: true, message: this.$t('create.validation.urlRequired'), trigger: ['blur', 'change'] },
					{ validator: idTaken, message: this.$t('create.validation.urlTaken'), trigger: ['blur', 'change'] },
					{ validator: idForbidden, message: this.$t('create.validation.urlForbidden'), trigger: ['blur', 'change'] },
					{ min: 4, message: this.$t('create.validation.minLength4'), trigger: 'blur' },
					{ max: 20, message: this.$t('create.validation.maxLength20'), trigger: ['blur', 'change'] },
					{
						validator: validateId,
						message: this.$t('create.validation.urlFormat'),
						trigger: ['blur', 'change'],
					},
				],
				password: [
					{ required: true, message: this.$t('create.validation.passwordRequired'), trigger: 'blur' },
					{ min: 6, message: this.$t('create.validation.passwordMin'), trigger: 'blur' },
				],
				checkPass: [
					{ required: true, message: this.$t('create.validation.confirmRequired'), trigger: 'blur' },
					{ validator: validatePass, message: this.$t('create.validation.passwordsDoNotMatch'), trigger: 'blur' },
				],
			},
			forbiddenIds: ['rambox', 'root', 'admin', 'test', 'testing', 'development', 'dev', 'production', 'prod', 'pro'],
		};
	},
	computed: {
		// Sign-up lives in the auth app; carry the language over with it.
		signUpUrl(): string {
			return this.$withLocale(
				'https://auth-legacy.rambox.app/website?redirect_uri=https%3A%2F%2Frambox.app%2Fthanks-joining%2F&response_type=token&scope=organization%20email'
			);
		},
	},
	watch: {
		'form.organizationName'(newValue, oldValue) {
			if (newValue === oldValue) return;
			if (newValue === '') return (this.form.organizationId = '');
			let value = newValue.slice(-1) === '.' ? newValue.slice(0, -1) : newValue;
			this.form.organizationId = this.tenantList.includes(newValue.toLowerCase())
				? `${value.replace(/[\. ,:-]+/g, '-').toLowerCase()}${Math.floor(Math.random() * Math.floor(9))}`
				: value.replace(/[\. ,:-]+/g, '-').toLowerCase();
		},
		'form.organizationId'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.form.organizationId = newValue.toLowerCase();
		},
		'form.email'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.form.email = newValue.toLowerCase();
		},
	},
	methods: {
		async validateForm(): Promise<boolean> {
			try {
				return await this.$refs.form.validate();
			} catch (error) {
				return false;
			}
		},
		async getTenantList(): Promise<void> {
			try {
				const response = await this.$firebase.functions().httpsCallable('getTenantList')();
				this.tenantList = response.data;
			} catch (error) {
				console.error(error);
				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async createOrganization(): Promise<void> {
			if (this.loading) return;
			try {
				this.loading = true;
				const response = await this.$firebase.functions().httpsCallable('createOrganization')({
					...this.form,
					workspaceVersion: '2.0.0',
				});
				this.$firebase.auth().tenantId = response.data.tenantId;
				await this.$firebase.auth().signInWithEmailAndPassword(response.data.email, response.data.password);
				this.loading = false;
			} catch (error) {
				console.error(error);
				this.loading = false;
				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async nextStep(): Promise<void> {
			const valid = await this.validateForm();
			if (!valid) return;
			this.step++;
			this.focusField();
			setTimeout(() => {
				this.$refs.form.clearValidate();
			}, 5);
		},
		async stepClickHandler(step): Promise<void> {
			if (step > this.step) return;
			this.step = step - 1;
			this.focusField();
		},
		focusField(): void {
			setTimeout(() => this.$refs[`inputStep_${this.step}`] && this.$refs[`inputStep_${this.step}`].focus(), 200);
		},
	},
	async mounted() {
		this.getTenantList();
		this.focusField();
	},
};
